define('commons/callback-selector',['jquery'], function($) {
    var CallbackSelector = function(typeSelector, subtypeSelector, channelSelector, options) {

        this.typeContainer = $(typeSelector);
        this.channelContainer = $(channelSelector);
        this.subtypeContainer = $(subtypeSelector);
        this.eventtypeContainer = options.eventtypeSelector ? $(options.eventtypeSelector) : null;
        this.data = options.data;
        this.customVariables = options.customVariables;
        this.restrictions = options.restrictions;
        this.first = true;
        if (typeof options.onChange === 'function') {
            this.onChange = $.proxy(options.onChange, this);
        }

        var displayChannels = $.proxy(function(channels) {
            this.channelContainer.empty();
            for (var ch in channels) {
                this.channelContainer.append('<option value="' + ch + '"' + (options.channelSelected == ch ? 'selected="selected"' : '') + '>' + ch +
                        '</option>');
            }
            // use init value only once
            options.channelSelected = '';
            this.channelContainer.trigger("change");
        }, this);

        this.typeContainer.change($.proxy(function(event) {
            var code = $(event.currentTarget).val();
            this.subtypeContainer.empty();
            var callbackType = this.data[code];

            if (typeof callbackType.subtypes != 'undefined') {
                var subtypes = callbackType.subtypes;
                var only = (this.restrictions||{})[callbackType.name];
                
                for (var st in subtypes) {
                	if (only && only.indexOf(subtypes[st].name) < 0) {
                		continue;
                	}
                    this.subtypeContainer.append('<option value="' + st + '"' + (options.subtypeSelected == st ? 'selected="selected"' : '') + '>' +
                            subtypes[st].name + '</option>');
                }
                // use init value only once
                options.subtypeSelected = '';
                $('#callbackSubtype').show();
                this.subtypeContainer.trigger("change");
            } else if (typeof callbackType.eventtypes != 'undefined') {
                $('#callbackSubtype').hide();
                this.eventtypeContainer.trigger("change");
            } else {
                $('#callbackSubtype').hide();
                displayChannels(callbackType.channels);
            }
        }, this));

        this.subtypeContainer.change($.proxy(function(event) {
            var code = $(event.currentTarget).val();
            var typeCode = this.typeContainer.val();


            displayChannels(this.data[typeCode].subtypes[code].channels);
        }, this));

        if (this.eventtypeContainer) {
            this.eventtypeContainer.change($.proxy(function(event) {
                var code = $(event.currentTarget).val();
                var typeCode = this.typeContainer.val();
                displayChannels(this.data[typeCode].eventtypes[code].channels);
            }, this));
        }

        this.channelContainer.change($.proxy(function(event) {
            var code = this.typeContainer.find('option:selected').val();
            var channel = $(event.currentTarget).val();
            var callbackType = this.data[code];
            var callbackSubType;
            var channelObject;
            var isGeoloc = false;
            if (typeof callbackType.subtypes != 'undefined') {
                channelObject = callbackType.subtypes[this.subtypeContainer.val()].channels[channel];
               	callbackSubType = callbackType.subtypes[this.subtypeContainer.val()];
       	        if(callbackSubType.name == 'GEOLOC'){
       	        	isGeoloc = true;
       	        }
            } else if (typeof callbackType.eventtypes != 'undefined') {
                channelObject = callbackType.eventtypes[this.eventtypeContainer.val()].channels[channel];
            } else {
                channelObject = this.data[code].channels[channel];
            }
            
            var geolocInfo = $("#geolocInfo");
            isGeoloc ? geolocInfo.show() : geolocInfo.hide();
            
            $('#delay-disclamer').toggle('DATA_ADVANCED' == (callbackSubType||{}).name);

            if ('DATA' == callbackType.name || 'DATA_ADVANCED' == (callbackSubType||{}).name) {
                $('#payloadConfig-field').show();
                var customVariables  = this.customVariables();
                if (customVariables && customVariables.length > 0) {
                    $('div.customVariables').show();
                    $('.custom-variables').html(customVariables.map(function(v) { return v.name; }).join(', '));
                }
            } else {
                $('#payloadConfig-field').hide();
                $('div.customVariables').hide();
            }
            if (!this.first) {
                this.onChange(channel, channelObject, callbackType, callbackSubType);
            } else {
                this.first = false;
                // init variables
                var $div = $("#callbackTemplate");
                $div.find('.default-variables').html(channelObject.defaultVariables.map(function(v) { return v.name; }).join(', '));
                if (channelObject.extraVariables && channelObject.extraVariables.length > 0) {
                    $div.find('.extra-variables').html(channelObject.extraVariables.map(function(v) { return v.name; }).join(', '));
                    $('div.extraVariables').show();
                } else {
                    $('div.extraVariables').hide();
                }
            }
        }, this));

        // Fill first select
        for (var code in this.data) {
            var type = this.data[code];
            if (this.restrictions && !this.restrictions[type.name]) {
            	continue;
            }
            
            this.typeContainer.append('<option value="' + code + '" ' + (options.typeSelected == code ? 'selected="selected"' : '') + '>' +
                    type.name + '</option>');
        }
        this.reload();
    };

    CallbackSelector.prototype.reload = function() {
        this.typeContainer.change();
    };

    CallbackSelector.prototype.getVariables = function(noExtra) {
        var code = this.typeContainer.find('option:selected').val();
        var callbackType = this.data[code];
        var callbackSubType;
        var channel = $('#callbackChannel').val();
        var channelObject;
        if (typeof callbackType.subtypes != 'undefined') {
           	callbackSubType = callbackType.subtypes[this.subtypeContainer.val()];
            channelObject = callbackSubType.channels[channel];
        } else if (typeof callbackType.eventtypes != 'undefined') {
            channelObject = callbackType.eventtypes[this.eventtypeContainer.val()].channels[channel];
        } else {
            channelObject = callbackType.channels[channel];
        }
        
        var toReturn = channelObject.defaultVariables;
        if (!noExtra) {
        	toReturn = toReturn.concat(channelObject.extraVariables);
        }
        if('EVENT' != callbackType.name) {
            var customVariables = this.customVariables();
        }
        if(('DATA' == callbackType.name || 'DATA_ADVANCED' == (callbackSubType||{}).name) && customVariables) {
            return toReturn.concat(customVariables);
        }
        return toReturn;
    };

    return CallbackSelector;
});
